Ext.define('SA.LineCounter', {
    constructor({cls}) {
        var el = document.createElement('div'),
            styleTarget = document.createElement('div'),
            textTarget = this.textTarget = document.createElement('span');

        el.classList.add('sa-line-counter');
        el.append(styleTarget);

        styleTarget.className = cls;
        styleTarget.append(textTarget);

        document.body.append(el);
    },

    count(text) {
        this.textTarget.textContent = text;

        return this.textTarget.getClientRects().length;
    }
});